/** @jsxImportSource @emotion/react */

import AppBar from "@mui/material/AppBar";
import { Box } from "react-feather";
import { headerHeight } from "../../../R";

export function HeaderFixedOnTop({ children }: Readonly<{ readonly children: React.ReactNode }>) {
  return (
    <>
      <Box css={{ height: headerHeight, width: "100%" }}></Box>
      <AppBar enableColorOnDark css={{ height: headerHeight, zIndex: 3, boxShadow: "none" }}>
        {children}
      </AppBar>
    </>
  );
}
